import "../../sass/pages/_partnership-betsson.scss";
import TestimonialsSlider from "../components/partnership-betsson/testimonials-slider";
import CaseStudiesSlider from "../components/partnership-betsson/case-studies-slider";
import BetssonTabs from "../components/partnership-betsson/betsson-tabs";

document.addEventListener("DOMContentLoaded", () => {
  window.customElements.define("testimonials-slider", TestimonialsSlider);
  window.customElements.define("case-studies-slider", CaseStudiesSlider);
  window.customElements.define("betsson-tabs", BetssonTabs);
  
  // Init hero animation
  const heroEl = document.querySelector('[data-hero-animation]');
  if (heroEl && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            heroEl.classList.add('in-viewport');
            observer.unobserve(heroEl);
          }
        });
      },
      {
        threshold: 0.35
      }
    );
    observer.observe(heroEl);
  }

});
